import { setRelAttribute } from '@trip-ux/common';
import React, { FC } from 'react';
import { NavMenuLang } from './SideNavTypes';

export const NavLanguage: FC<NavMenuLang> = ({ ariaLabel, className, label, href, hrefLang, onLanguageToggle }) => {
  return (
    <a
      data-testid="language"
      className={className}
      aria-label={ariaLabel || label}
      hrefLang={hrefLang}
      href={href}
      onClick={onLanguageToggle}
      rel={setRelAttribute(href)}>
      {label}
    </a>
  );
};
